var canvas: HTMLCanvasElement;
var context: CanvasRenderingContext2D;

// system variables
var last_tick_t = 0;
var width: number;
var height: number;
var keyStates: Set<string> = new Set();
var mouseX = 0;
var mouseY = 0;

// game variables
var innerFields: number[][][][];
var outerField: number[][];
var currentPlayer: number;
var fieldRestrictionX: number;
var fieldRestrictionY: number;
var won: number;

function initialize() {
    won = 0;
    fieldRestrictionX = -1;
    fieldRestrictionY = -1;
    currentPlayer = 1;
    innerFields = [];
    outerField = [];
    for(let x=0; x<3; x++) {
        innerFields[x] = [];
        outerField[x] = [];
        for(let y=0; y<3; y++) {
            innerFields[x][y] = [];
            outerField[x][y] = 0;
            for(let i=0; i<3; i++) {
                innerFields[x][y][i] = []
                for(let j=0; j<3; j++) {
                    innerFields[x][y][i][j] = 0;
                }
            }
        }
    }
}

function drawTicTacToeField(field: number[][]) {
    context.beginPath();
    context.moveTo(100, 0);
    context.lineTo(100,300);
    context.moveTo(200, 0);
    context.lineTo(200,300);
    context.moveTo(0, 100);
    context.lineTo(300, 100);
    context.moveTo(0, 200);
    context.lineTo(300,200);
    for(let x=0; x<3; x++) {
        for(let y=0; y<3; y++) {
            if(field[x][y] == 1) {
                context.moveTo(80+100*x, 50+100*y);
                context.arc(50+100*x, 50+100*y, 30,0,2*Math.PI);
            }
            if(field[x][y] == 2) {
                context.moveTo(20+100*x, 20+100*y);
                context.lineTo(80+100*x, 80+100*y);
                context.moveTo(20+100*x, 80+100*y);
                context.lineTo(80+100*x, 20+100*y);
            }
        }
    }
    context.stroke();
}

function draw() {
    context.resetTransform();
    context.clearRect(0, 0, 900, 900);
    // select color
    context.fillStyle = "black";

    let testField = [[0,1,2],[0,1,0],[1,2,0]];
    for(let x=0; x<3; x++) {
        for(let y=0; y<3; y++) {
            if(outerField[x][y] == -1) {
                context.fillStyle = "light grey";
                context.fillRect(0, 0, 300, 300);
                context.fillStyle = "black";
            }
            drawTicTacToeField(innerFields[x][y]);
            context.translate(0,300);
        }
        context.translate(300,-900);
    }
    context.resetTransform();
    context.scale(3,3);
    drawTicTacToeField(outerField);
    context.strokeStyle = "red";
    if(fieldRestrictionX != -1) {
        context.strokeRect(fieldRestrictionX*100, fieldRestrictionY*100, 100, 100);
    } else {
        context.strokeRect(0, 0, 300, 300);
    }
    context.strokeStyle = "black";
    context.scale(3,3);
    context.beginPath();
    if(won == 1) {
        context.moveTo(80, 50);
        context.arc(50, 50, 30,0,2*Math.PI);
    }
    if(won == 2) {
        context.moveTo(20, 20);
        context.lineTo(80, 80);
        context.moveTo(20, 80);
        context.lineTo(80, 20);
    }
    context.stroke();
}
/*
function resized() {
    width = window.innerWidth;
    height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;
    draw();
}
*/

function key(e: KeyboardEvent) {
    switch (e.type) {
        case "keydown":
            keyStates.add(e.key);
            if(e.key == "r") {
                initialize();
            }
            break;
        case "keyup":
            keyStates.delete(e.key);
            break;
        default:
            console.warn("Wut?");
    }
}

function checkWin(field: number[][]) {
    if(field[0][0] != 0 && field[0][0] == field[0][1] && field[0][1] == field[0][2]) {
        return field[0][0];
    }
    if(field[1][0] != 0 && field[1][0] == field[1][1] && field[1][1] == field[1][2]) {
        return field[1][0];
    }
    if(field[2][0] != 0 && field[2][0] == field[2][1] && field[2][1] == field[2][2]) {
        return field[2][0];
    }

    if(field[0][0] != 0 && field[0][0] == field[1][0] && field[1][0] == field[2][0]) {
        return field[0][0];
    }
    if(field[0][1] != 0 && field[0][1] == field[1][1] && field[1][1] == field[2][1]) {
        return field[0][1];
    }
    if(field[0][2] != 0 && field[0][2] == field[1][2] && field[1][2] == field[2][2]) {
        return field[0][2];
    }

    if(field[0][0] != 0 && field[0][0] == field[1][1] && field[1][1] == field[2][2]) {
        return field[0][0];
    }
    if(field[2][0] != 0 && field[2][0] == field[1][1] && field[1][1] == field[0][2]) {
        return field[2][0];
    }
    if(field[0][0] != 0 && field[0][1] != 0 && field[0][2] != 0
        && field[1][0] != 0 && field[1][1] != 0 && field[1][2] != 0
        && field[2][0] != 0 && field[2][1] != 0 && field[2][2] != 0) {
            return -1;
    }
    return 0;
}

function click(e: MouseEvent) {
    let x = Math.floor(e.offsetX/300);
    let y = Math.floor(e.offsetY/300);
    let innerX = Math.floor((e.offsetX/300-x)*3);
    let innerY = Math.floor((e.offsetY/300-y)*3);
    if(won == 0 && outerField[x][y] == 0 && innerFields[x][y][innerX][innerY] == 0
        && (fieldRestrictionX == -1 || (x == fieldRestrictionX && y == fieldRestrictionY))) {
        innerFields[x][y][innerX][innerY] = currentPlayer;
        currentPlayer = 3-currentPlayer;
        let win = checkWin(innerFields[x][y]);
        if(win > 0) {
            outerField[x][y] = win;
            win = checkWin(outerField);
            if(win > 0) {
                won = win;
            }
        }
        if(outerField[innerX][innerY] == 0) {
            fieldRestrictionX = innerX;
            fieldRestrictionY = innerY;
        } else {
            fieldRestrictionX = -1;
            fieldRestrictionY = -1;
        }
    }
    draw();
}

function restart() {
    initialize();
    draw();
}

function mousemove(e: MouseEvent) {
    mouseX = e.offsetX;
    mouseY = e.offsetY;
}

function main() {
    initialize();
    canvas = document.getElementById("canvas") as HTMLCanvasElement;
    context = canvas.getContext("2d")!;
    window.addEventListener("keydown", key);
    window.addEventListener("keyup", key);
    //window.addEventListener("resize", resized);
    canvas.addEventListener("click", click);
    canvas.addEventListener("mousemove", mousemove);
    let restartbutton = document.getElementById("newgame");
    restartbutton.addEventListener("click", restart);
    //resized();
    draw();
}


main();